import { createContext, useContext } from 'react';

/**
 * Whether the page around a section shows a hero in the active phase. A section that can stand at
 * the top of a page in place of the hero (Program 2027) reads it to pick its heading level: the
 * page's `<h1>` when there is no hero, an `<h2>` under the hero's when there is. False outside a
 * page, such as in the preview gallery.
 */
export const PageHasHeroContext = createContext(false);

export function usePageHasHero(): boolean {
  return useContext(PageHasHeroContext);
}
